import { sendResetPasswordEmail } from 'api/auth'
import { resendConfirmationForTransaction } from 'api/order'
import { ChatActions, createGenesysConversation } from 'api/support'

const resetPasswordAction = (messageMeta) => {
  const email = messageMeta?.payload?.email || messageMeta?.payload?.inputPayload

  if (email) {
    sendResetPasswordEmail(email)
  }
}

const resendConfirmationEmailAction = (messageMeta) => {
  if (messageMeta?.payload?.id_orders) {
    resendConfirmationForTransaction(messageMeta.payload.id_orders)
  }
}

const createGenesysConversationAction = (messageMeta) => {
  const { chatId, firstName, lastName } = messageMeta.payload

  createGenesysConversation({
    chatId,
    customer: {
      firstName,
      lastName,
    },
  })
}

const manageBookingAction = (messageMeta) => {
  const { id_orders } = messageMeta.payload
  window.open(`/account/my-escapes/order/${id_orders}`, '_blank')
}

export const chatActions = {
  [ChatActions.RESET_PASSWORD_SENT]: resetPasswordAction,
  [ChatActions.RESEND_CONFIRMATION_EMAIL]: resendConfirmationEmailAction,
  [ChatActions.REQUEST_AGENT]: createGenesysConversationAction,
  [ChatActions.MANAGE_BOOKING]: manageBookingAction,
}
